import {
  ApprovalStatusEnum,
  AssignEmployeeColumnKey,
  ItemManagementType,
  ProcessType,
  RateSettingType,
  SubcontractorStatusEnum,
  SubcontractorType,
  UIConfig,
  UserType,
} from '../enum';

export const WS_REGISTER_ROUTE = '/websocket/';
export const WS_SOCKET = import.meta.env.VITE_SOCKET_URL + WS_REGISTER_ROUTE;
export const SHORT_DATE_FORMAT_API = 'YYYY-MM-DD';
export const LONG_DATE_FORMAT_API = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
export const SHORT_DATE_FORMAT = 'DD/MM/YYYY';
export const LONG_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const VALUE_EMPTY_TABLE = '—';
export const SHORT_TIME_FORMAT = 'HH:mm';
export const LONG_TIME_FORMAT = 'HH:mm:ss';

export const SORT_KEYS = {
  ascend: 'asc',
  descend: 'desc',
};

export const STATES = [
  {
    label: 'Queensland',
    value: 'Queensland',
  },
  {
    label: 'Tasmania',
    value: 'Tasmania',
  },
  {
    label: 'New South Wales',
    value: 'NewSouthWales',
  },
  {
    label: 'Victoria',
    value: 'Victoria',
  },
  {
    label: 'Western Australia',
    value: 'WesternAustralia',
  },
  {
    label: 'South Australia',
    value: 'SouthAustralia',
  },
  {
    label: 'Northern Territory',
    value: 'NorthernTerritory',
  },
  {
    label: 'Australian Capital Territory',
    value: 'AustralianCapitalTerritory',
  },
];

export const USER_TYPE_OPTIONS = [
  {
    value: UserType.Office,
    label: 'Office',
  },
  {
    value: UserType.Subcontractor,
    label: 'Subcontractor',
  },
  {
    value: UserType.Production,
    label: 'Production',
  },
  {
    value: UserType.Engineering,
    label: 'Engineering',
  },
  {
    value: UserType.ProcessWorker,
    label: 'Process Worker',
  },
];

export const SUBCONTRACTOR_SUB_PATH = {
  [SubcontractorType.All]: '',
  [SubcontractorType.LaserCutting]: 'LaserCutting',
  [SubcontractorType.InsulationCutting]: 'InsulationCutting',
  [SubcontractorType.RollForming]: 'RollForming',
  [SubcontractorType.Folding]: 'Folding',
};

export const SUBCONTRACTOR_FILTER_TYPE = {
  [SubcontractorType.All]: UIConfig.SubcontractorAll,
  [SubcontractorType.LaserCutting]: UIConfig.SubcontractorLaserCutting,
  [SubcontractorType.InsulationCutting]: UIConfig.SubcontractorInsulation,
  [SubcontractorType.RollForming]: UIConfig.SubcontractorRollForming,
  [SubcontractorType.Folding]: UIConfig.SubcontractorFolding,
};

export const SUBCONTRACTOR_DETAIL_TITLE = {
  [SubcontractorType.All]: '',
  [SubcontractorType.LaserCutting]: 'Laser Cutting',
  [SubcontractorType.InsulationCutting]: 'Insulation Cutting',
  [SubcontractorType.RollForming]: 'Roll-forming',
  [SubcontractorType.Folding]: 'Folding',
};

export const ITEMS_UNIT_PATH = {
  [ItemManagementType.ImportDate]: 'ItemImportDate',
  [ItemManagementType.QCDate]: 'ItemQCDate',
  [ItemManagementType.DeliveredDate]: 'ItemDeliveredDate',
};

export const ITEMS_FILTER_TYPE = {
  [ItemManagementType.ImportDate]: UIConfig.ItemImportDate,
  [ItemManagementType.QCDate]: UIConfig.ItemQCDate,
  [ItemManagementType.DeliveredDate]: UIConfig.ItemDeliveredDate,
};

export const SUBCONTRACTOR_STATUS_OPTIONS = [
  {
    value: SubcontractorStatusEnum.Pending,
    key: SubcontractorStatusEnum.Pending,
    label: 'Pending',
  },
  {
    value: SubcontractorStatusEnum.Released,
    key: SubcontractorStatusEnum.Released,
    label: 'Released',
  },
  {
    value: SubcontractorStatusEnum.InProgress,
    key: SubcontractorStatusEnum.InProgress,
    label: 'In Progress',
  },
  {
    value: SubcontractorStatusEnum.Done,
    key: SubcontractorStatusEnum.Done,
    label: 'Done',
  },
];

export const TRANSLATION_FIELD_VALUES = [
  'hasStarted',
  'hasFinished',
  'hasTransferred',
  'hasApproved',
  'hasPaid',
  'hasSubcontracted',
  'status',
  'laserStatus',
  'insulationStatus',
  'rollFormingStatus',
  'foldingStatus',
  'deliveredVerify',
  'qcVerify',
];

export const APPROVAL_STATUS_OPTIONS = [
  {
    value: ApprovalStatusEnum.Pending,
    key: ApprovalStatusEnum.Pending,
    label: 'Pending',
  },
  {
    value: ApprovalStatusEnum.Approved,
    key: ApprovalStatusEnum.Approved,
    label: 'Approved',
  },
  {
    value: ApprovalStatusEnum.Rejected,
    key: ApprovalStatusEnum.Rejected,
    label: 'Rejected',
  },
];

export const RATE_SETTING_TYPE_OPTIONS = [
  {
    value: RateSettingType.ItemFault,
    label: 'Item Fault Labour Rate',
  },
  {
    value: RateSettingType.ProductionFault,
    label: 'Production Fault Labour Rate',
  },
  {
    value: RateSettingType.LaserCutting,
    label: 'Laser Cutting Rate',
  },
  {
    value: RateSettingType.InsulationCutting,
    label: 'Insulation Cutting Rate',
  },
  {
    value: RateSettingType.RollForming,
    label: 'Roll-forming Rate',
  },
  {
    value: RateSettingType.Folding,
    label: 'Folding Rate',
  },
];

export const LEVEL_OPTIONS = [
  {
    key: '1',
    label: 'Level 1',
  },
  {
    key: '2',
    label: 'Level 2',
  },
  {
    key: '3',
    label: 'Level 3',
  },
  {
    key: '4',
    label: 'Level 4',
  },
  {
    key: '5',
    label: 'Level 5',
  },
];

export const CONFIG_FILTER_DEFAULT = [
  {
    name: 'jobIds',
    span: 6,
    label: 'Job ID',
  },
  {
    name: 'parts',
    span: 6,
    label: 'Part',
  },
  {
    name: 'actions',
    span: 6,
    label: 'Action',
  },
  {
    name: 'names',
    span: 6,
    label: 'Name',
  },
];

export const FILTER_EXCLUDED_NAMES = ['searchText'];

export const CAPITALIZE_FILTER_NAMES = ['qc'];

export const PROCESS_LIST = [
  {
    value: ProcessType.Assembly,
    label: 'Assembly',
  },
  {
    value: ProcessType.Capping,
    label: 'Capping',
  },
  {
    value: ProcessType.InsulationFit,
    label: 'Insulation Fit',
  },
  {
    value: ProcessType.Seal,
    label: 'Seal',
  },
];

export const COMPONENT_MATCHING_COLUMNS = [
  'Factory Fit',
  'Insulation',
  'Part',
  'Perfmetal',
  'Skin',
];

export const REQUIRED_RULE = {
  required: true,
  message: 'This field is required',
};

export const ASSIGN_EMPLOYEE_COLUMN_CONFIG = {
  [AssignEmployeeColumnKey.Assembly]: {
    key: AssignEmployeeColumnKey.Assembly,
    label: 'Assembly',
    color: '#3B82F6',
    borderColor: '#CFE3FD',
    columnType: 'Assembly',
  },
  [AssignEmployeeColumnKey.Capping]: {
    key: AssignEmployeeColumnKey.Capping,
    label: 'Capping',
    color: '#FB923C',
    borderColor: '#FFE0B7',
    columnType: 'Capping',
  },
  [AssignEmployeeColumnKey.Insulation]: {
    key: AssignEmployeeColumnKey.Insulation,
    label: 'Insulation Fit',
    color: '#EDB72B',
    borderColor: '#FFF2C0',
    columnType: 'InsulationFit',
  },
  [AssignEmployeeColumnKey.Seal]: {
    key: AssignEmployeeColumnKey.Seal,
    label: 'Seal',
    color: '#64748B',
    borderColor: '#E4E4E4',
    columnType: 'Seal',
  },
  [AssignEmployeeColumnKey.OtherProcess]: {
    key: AssignEmployeeColumnKey.OtherProcess,
    label: 'Other Process',
    color: '#CA9F74',
    borderColor: '#F0DFCE',
    columnType: 'OtherProcess',
  },
  [AssignEmployeeColumnKey.Unassigned]: {
    key: AssignEmployeeColumnKey.Unassigned,
    label: 'Unassigned',
    color: '#F43F5E',
    borderColor: '#FFDEDE',
    columnType: 'Unassigned',
  },
  [AssignEmployeeColumnKey.NotAvailable]: {
    key: AssignEmployeeColumnKey.NotAvailable,
    label: 'Not Available',
    color: '#94A3B8',
    borderColor: '#F0DFCE',
    columnType: 'NotAvailable',
  },
  [AssignEmployeeColumnKey.OnHoliday]: {
    key: AssignEmployeeColumnKey.OnHoliday,
    label: 'On Holiday',
    color: '#10B981',
    borderColor: '#CCFAE3',
    columnType: 'Holiday',
  },
};

export const MAPPING_PROCESS_TO_COLUMN_KEY: Record<
  ProcessType,
  AssignEmployeeColumnKey
> = {
  [ProcessType.Assembly]: AssignEmployeeColumnKey.Assembly,
  [ProcessType.Capping]: AssignEmployeeColumnKey.Capping,
  [ProcessType.InsulationFit]: AssignEmployeeColumnKey.Insulation,
  [ProcessType.Seal]: AssignEmployeeColumnKey.Seal,
};

export const LOCK_OPTIONS = [
  {
    value: 'true',
    key: 'true',
    label: 'Yes',
  },
  {
    value: 'false',
    key: 'false',
    label: 'No',
  },
];

export const CALCULATION_PROCESS_STEPS = [
  {
    name: 'Assembly',
    value: 'Assembly',
  },
  {
    name: 'Capping',
    value: 'Capping',
  },
  {
    name: 'Insulation Fit',
    value: 'InsulationFit',
  },
  {
    name: 'Seal',
    value: 'Seal',
  },
];

export const PROCESS_TIME_INPUT_SELECT = [
  {
    value: 'Input 1',
    label: 'Input 1',
  },
  {
    value: 'Input 2',
    label: 'Input 2',
  },
  {
    value: 'Input 3',
    label: 'Input 3',
  },
  {
    value: 'Input 4',
    label: 'Input 4',
  },
];

export const COMPONENT_TYPE = [
  {
    key: 'Insulation',
    label: 'Insulation',
    value: 'Insulation',
  },
  {
    key: 'Part',
    label: 'Part',
    value: 'Part',
  },
  {
    key: 'Perfmetal',
    label: 'Perfmetal',
    value: 'Perfmetal',
  },
  {
    key: 'Factory Fit',
    label: 'Factory Fit',
    value: 'Factory Fit',
  },
  {
    key: 'Skin',
    label: 'Skin',
    value: 'Skin',
  },
];

export const COMPONENT_ITEM_TYPE = [
  {
    key: 'Item',
    label: 'Item',
    value: 'Item',
  },
];

export const DEFECT_LEVEL_OPTIONS = [
  {
    key: 'Critical',
    label: 'Critical',
  },
  {
    key: 'High',
    label: 'High',
  },
  {
    key: 'Medium',
    label: 'Medium',
  },
  {
    key: 'Low',
    label: 'Low',
  },
];

export const TREE_EXPAND_SPACER_COLUMN = {
  title: ' ',
  dataIndex: '__tree_expand_spacer__',
  key: '__tree_expand_spacer__',
  width: 40,
  render: () => null,
};
